import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { i18n } from '@/plugins/i18n'

import VueAnalytics from 'vue-analytics'

import './plugins/settings'

Vue.config.productionTip = false
Vue.config.devtools = process.env.VUE_APP_DEVTOOLS

Vue.use(VueAnalytics, {
	id: 'UA-173047432-1',
	router
})

new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App)
}).$mount('#app')
